import { create } from "apisauce";

const baseURL = "./rest/back/";
//const baseURL = "https://api.mobiclean.tech/rest/back/";
//const baseURL = "http://192.168.1.26:8080/mobiservices/rest/back/";
// const baseURL =  "http://192.168.43.112:8080/ekokleanondemand/rest/back/";

const apiClient = create({
  baseURL,
  timeout: 60000,
  headers: {
    "x-senef-mobi-key": "6512256c-d553-4472-98b4-9f8c47556e04",
  },
});

const get = apiClient.get;

apiClient.get = async (url, params, axiosConfig) => {
  const response = await get(url, params, axiosConfig);

  if (!response.ok && (response.status === 401 || response.status === 403)) {
    localStorage.removeItem("currentUser");
  }

  return response;
};

const post = apiClient.post;

apiClient.post = async (url, data, axiosConfig) => {
  const response = await post(url, data, axiosConfig);

  if (!response.ok && (response.status === 401 || response.status === 403)) {
    localStorage.removeItem("currentUser");
  }

  return response;
};

export { apiClient, baseURL };
